module.exports = __webpack_public_path__ + "static/media/AI-ML-Development.bced2272.png";